import { Component, Input, OnInit, OnDestroy, ComponentRef } from '@angular/core';
import { ProjectService } from '../../../services/project.service';
import { SettingsService } from '../../../services/settings.service';
import { Sprint } from '../../../models/sprint';
import { SettingsEventType } from '../../../models/enums/settingsEventType';
import { Subscription } from 'rxjs';
import { IWidget } from '../../../interfaces/iWidget';

@Component({
  selector: 'app-releaseplanning-widget',
  templateUrl: './releaseplanning-widget.component.html',
  styleUrls: ['./releaseplanning-widget.component.scss']
  })
export class ReleaseplanningWidgetComponent implements OnInit, OnDestroy, IWidget {
  static widgetName = 'releaseplanning';
  projectKeys: string[];
  sprints: Sprint[];
  selectedProjectKey: string;
  public projectId;
  @Input() widget = true;
  private subscriptions: Subscription[] = [];
  // style
  public zIndex = 25;
  // callbacks
  public setPosition;
  // ref
  public componentRef: ComponentRef<any>;
  public isUndocked: boolean;

  constructor(
    private projectService: ProjectService,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.setCurrentProject();
    this.subscriptions.push(this.settingsService.getUpdateObservable().subscribe(settingsEventType => {
      if (settingsEventType === SettingsEventType.SPRINT_CHANGED
        || settingsEventType === SettingsEventType.PROJECT_CHANGED) {
        this.setCurrentProject();
      }
    }));
    this.loadProjectData();
  }

  ngOnDestroy(): void {
    for (const ev of this.subscriptions) {
      ev.unsubscribe();
    }
  }

  setCurrentProject(): void {
    this.selectedProjectKey = this.settingsService.getProjectName();
    this.projectService.getProjectByKey(this.selectedProjectKey).subscribe((project) => {
      this.projectId = project.id;
    });
  }

  /**
   * Load all Projects to populate Project-Select-Options.
   */
  loadProjectData(): void {
    this.projectService.getKeysOfAvailableProjects().subscribe(fetchedProjects => {
      this.projectKeys = fetchedProjects;
      this.saveProject(this.selectedProjectKey);
    });
  }

  saveProject(projectName: string): void {
    if (projectName) {
      this.projectService.getProjectByKey(projectName).subscribe(existProject => {
        if (existProject === null) {
          // save project in database if not contain, project key is unique
          this.projectService.saveProjectOnInitialisation(projectName).subscribe(project => {
            this.projectId = project['id'];
            // project is set call listeners for update
            this.settingsService.emitSettingsUpdate(SettingsEventType.PROJECT_CHANGED, this.constructor.name);
          });
        } else {
          this.projectId = existProject['id'];
          this.settingsService.emitSettingsUpdate(SettingsEventType.PROJECT_CHANGED, this.constructor.name);
        }
      });
    }
  }

  onSelectedProjectChanged(): void {
    this.settingsService.setProjectKey(this.selectedProjectKey);
    this.settingsService.emitSettingsUpdate(SettingsEventType.PROJECT_CHANGED, this.constructor.name);
    this.loadProjectData();
  }

}
